import { Rpc } from "./rpc";

export class MetaRpc {

    public static get(): Promise<MetaDto> {
        return Rpc.GET("/rpc/meta/get");
    }

    private constructor() {}

}

export interface MetaDto {

    readonly userId: number;
    readonly userName: string;
    readonly email: string;
    readonly companyId: number;
    readonly companyName: string;
    readonly role: TUserRole;
    readonly vacationTypes: MetaVacationTypeDto[];
    readonly users: MetaUserItemDto[];

}

export interface MetaVacationTypeDto {
    readonly id: string;
    readonly name: string;
    readonly color: string;
}

export interface MetaUserItemDto {

    id: number;
    name: string;

}

export type TUserRole = "USER" | "HR" | "ADMIN" | "OWNER";